import React, { useState, useEffect } from 'react';
import Styles from './InformationToolTip.module.scss';
import Icon from '@hobs/components/Icon';
import Tooltip from '@hobs/components/Tooltip';

const InformationToolTip = ({
  toolTipInformation,
  startDisabled,
  catalogItemId,
  hasMargins,
  isOpen,
  floatRight
}) => {
  const [toolTipOpen, setToolTipOpen] = useState(!startDisabled);
  const [toolTipInformationOld, setOldInformation] = useState(
    toolTipInformation
  );
  const [catalogItemIdOld, setOldItemId] = useState(catalogItemId);

  useEffect(() => {
    setToolTipOpen(isOpen);
  }, [isOpen]);

  if (toolTipInformation != toolTipInformationOld) {
    setToolTipOpen(true);
    setOldInformation(toolTipInformation);
  }

  if (catalogItemId != catalogItemIdOld) {
    setToolTipOpen(true);
    setOldItemId(catalogItemId);
  }

  const onToolTip = () => {
    setToolTipOpen(!toolTipOpen);
  };

  const tooltip = text => {
    return (
      <div class={Styles.ShowHide}>
        <div class={Styles.right} onClick={onToolTip}>
          <a>X</a>
        </div>
        <div class={Styles.left}>{text}</div>
      </div>
    );
  };

  return (
    <div
      className={`${Styles.ToolTip} ${hasMargins ? Styles.WithMargins : ''} ${
        floatRight ? Styles.FloatRight : ''
      }`}
    >
      <Tooltip
        tooltip={tooltip(toolTipInformation)}
        position="top"
        isOpen={toolTipOpen}
        popoverClassName={Styles['popover--popover']}
        className={Styles['popover']}
      >
        <div id="tooltip-icon" className={Styles.Icon} onClick={onToolTip}>
          <Icon icon="ExclamationMark" />
        </div>
      </Tooltip>
    </div>
  );
};

InformationToolTip.defaultProps = {
  hasMargins: true,
  isVisible: true,
  floatRight: true
};

export default InformationToolTip;
